/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 24/9/2020
 */

export const OperationState = Object.freeze({
	DEFAULT: 'DEFAULT',
	PROCESSING: 'PROCESSING',
	SUCCESS: 'SUCCESS',
	FAILED: 'FAILED',
})
